import { Injectable } from "@angular/core";
import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import moment from "moment";

@Injectable({
  providedIn: "root",
})
export class ValidatorsService {
  constructor() {}

  date(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      return moment(control.value).isValid() ? null : { date: true };
    };
  }

  digits(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      return /^[0-9]+$/.test(control.value) ? null : { digits: true };
    };
  }

  minDate(min: Date): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      return moment(control.value).isSameOrAfter(min)
        ? null
        : { minDate: true };
    };
  }

  maxDate(max: Date): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      return moment(control.value).isSameOrBefore(max)
        ? null
        : { maxDate: true };
    };
  }

  number(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      return /^[0-9]+$/.test(control.value) ? null : { number: true };
    };
  }

  url(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      const urlPattern =
        /^(https?:\/\/)?([\w\-]+\.)+[\w\-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;

      return urlPattern.test(control.value) ? null : { url: true };
    };
  }
}
